import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./nav-list.${locale}.json`));
